module.exports = __webpack_public_path__ + "static/media/p23.533c219e.png";